import _ from 'lodash';
import { ENV_DOMAIN } from '@/shared/config/env';
import LINK_CONFIG from './env';

/**
 * Completes the username and password Amplify configuration with redirect URLs and cookie-backed session storage. Spreads the base AWS config, enables ssr, points both oauth redirects at the environment link, and adds an Auth block whose cookie storage is scoped to localhost or the environment domain, kept for a year, sameSite strict and secure everywhere but localhost.
 *
 * @returns The Amplify configuration object with oauth redirects and cookie storage filled in.
 */
const updatedAwsConfig = () => ({
  ...LINK_CONFIG.AWS_CONFIG,
  ssr: true,
  oauth: {
    ...LINK_CONFIG.AWS_CONFIG.oauth,
    redirectSignIn: LINK_CONFIG.LINK_REDIRECT_AWS,
    redirectSignOut: LINK_CONFIG.LINK_REDIRECT_AWS,
  },
  Auth: {
    ...LINK_CONFIG.AWS_CONFIG,
    cookieStorage: {
      domain: window.location.hostname === 'localhost' ? 'localhost' : ENV_DOMAIN,
      path: '/',
      expires: 365,
      sameSite: 'strict',
      secure: !_.includes(window.location.hostname, 'localhost'),
    },
  },
});

export default updatedAwsConfig;
